<!--  -->
<template>
  <div>
    <div class="form_box">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="appId" label-width="90px">
          <el-input v-model="form.app_id" />
        </el-form-item>
        <el-form-item label="小程序名称" label-width="89px">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="ghId" label-width="89px">
          <el-input v-model="form.gh_id" />
        </el-form-item>
        <el-form-item label="路径" label-width="89px">
          <el-input v-model="form.pagepath" />
        </el-form-item>
        <el-form-item label-width="89px" label="备注">
          <div class="formimg">
            <el-input v-model="form.remark" />
          </div>
        </el-form-item>
        <el-form-item label="封面">
          <div class="formimg">
            <img v-if="form.source_material_id!=null" :src="source_material_img" alt="" style="width: 100px;height: 100px;margin-right: 10px;">
            <el-button type="success" size="mini" @click="chooseimg">选择封面</el-button>
            <span style="color:#ccc;margin-left: 10px;" class="font-m">小程序卡片图片建议大小为520*416</span>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addcread">立即创建</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="padding: 0 40px;text-align: right;"><el-button type="success" @click="updatae">刷新</el-button></div>
    <div style="padding:0 40px">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width:100%; height: 100%;"
        border
        max-height="500"
      >
        <el-table-column
          align="center"
          label="小程序名称"
          prop="name"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.name }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="小程序名称"
              width="200"
              trigger="hover"
              :content="scope.row.name"
            >
              <p slot="reference" class="titip">{{ scope.row.name }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.textName" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="小程序appid"
          prop="app_id"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.corp_id }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="小程序appid"
              width="200"
              trigger="hover"
              :content="scope.row.app_id"
            >
              <p slot="reference" class="titip">{{ scope.row.app_id }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.textAppId" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="ghId"
          prop="gh_id"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.secret }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="ghId"
              width="200"
              trigger="hover"
              :content="scope.row.gh_id"
            >
              <p slot="reference" class="titip">{{ scope.row.gh_id }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.textGhId" />
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="路径"
          prop="pagepath"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.secret }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="路径"
              width="200"
              trigger="hover"
              :content="scope.row.pagepath"
            >
              <p slot="reference" class="titip">{{ scope.row.pagepath }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.textPagepath" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="备注"
          prop="remark"
        >
          <template slot-scope="scope">
            <!-- <span v-if="!scope.row.isModify">{{ scope.row.secret }}</span> -->
            <el-popover
              v-if="!scope.row.isModify"
              placement="top-start"
              title="备注"
              width="200"
              trigger="hover"
              :content="scope.row.remark"
            >
              <p slot="reference" class="titip">{{ scope.row.remark }}</p>
            </el-popover>
            <el-input v-else v-model="scope.row.textRemark" />
          </template>
        </el-table-column>
        <el-table-column
          :key="mathRandom"
          label="操作"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <!-- <span v-show="!scope.row.isModify"> -->
            <el-button
              type="text"
              size="small"
              @click="editData(scope.row)"
            >
              <!-- @click.native.prevent="scope.row.isModify = true" -->
              修改
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="lookData(scope.row)"
            >
              <!-- @click.native.prevent="scope.row.isModify = true" -->
              预览
            </el-button>
            <!-- <el-button
                type="text"
                size="small"
                @click.native.prevent="deleteAccount(scope.row.id)"
              >
                删除
              </el-button> -->
            <!-- </span> -->
            <!-- <span v-show="scope.row.isModify">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="(scope.row.isModify = false),(scope.row.textAppId = scope.row.app_id),(scope.row.textName = scope.row.name),(scope.row.textGhId = scope.row.gh_id),(scope.row.textPagepath = scope.row.pagepath),(scope.row.textRemark = scope.row.remark)"
              >
                取消修改
              </el-button>
              <el-button
                type="text"
                size="small"
                @click.native.prevent="confirmAccount(scope.row)"
              >
                确认修改
              </el-button>
            </span> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletwo"
      class="popup-mid"
      append-to-body
    >
      <chooseimg ref="mychild" @clickicon="clickicon" />
    </el-dialog>
    <el-dialog
      :title="'修改'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      class="popup-mid"
    >
      <wechatdedit ref="wechatdeditview" @updata="updata" @updatawechat="updatawechat" />
    </el-dialog>
    <el-dialog
      title="预览"
      :visible.sync="priwdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      class="popup-mid"
    >
      <previewdialog ref="timepreview" />
    </el-dialog>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import previewdialog from './previewdialog.vue'

import wechatdedit from './wechatdedit.vue'
import chooseimg from '@/views/sourcematerialc/components/chooseimg.vue'
import { kfmpstorelist, kfmpstore, delteMicro, kfmpupdate, fetchUpMiniPrograms } from '@/api/providerAccountManagement/servicePorviderList1.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight, chooseimg, wechatdedit, previewdialog
  },
  data() {
    return {
      form: {
        app_id: '',
        gh_id: '',
        name: '',
        source_material_id: null,
        remark: null
      },
      stutes: null,
      pwdFlag: true, // 密码标示 true表示当前是密码形式
      account_name: '',
      login_pwd: '',
      pay_pwd: '',
      mathRandom: null,
      tableData: [],
      loading: false,
      query: {
        page: 1,
        page_size: 10
      },
      total: null,
      company_name: '',
      ster: null,
      source_material_img: '',
      dialogVisibletwo: false,
      dialogVisible: false,
      priwdialogVisible: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    updatawechat(alltype) {
      console.log(alltype, 'alltype')
      // eslint-disable-next-line eqeqeq
      if (alltype == 1) {
        this.dialogVisible = false
      } else {
        this.dialogVisiblewechat = false
      }
      this.accountlist()
    },
    updata() {
      this.dialogVisible = false
      this.accountlist()
    },
    editData(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.wechatdeditview.send(item, 2)
      })
    },
    lookData(item) {
      this.priwdialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(item, 1)
      }, 100)
    },
    clickicon(img, key) {
      this.dialogVisibletwo = false
      this.form.source_material_id = key
      this.source_material_img = img
    },
    chooseimg() {
      this.dialogVisibletwo = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    udaer() {
      this.accountlist()
    },
    async accountlist() {
      this.loading = true
      const data = await kfmpstorelist(this.query)
      for (let i = 0; i < data.data.list.length; i++) {
        data.data.list[i].textAppId = data.data.list[i].app_id
        data.data.list[i].textName = data.data.list[i].name
        data.data.list[i].textGhId = data.data.list[i].gh_id
        data.data.list[i].textPagepath = data.data.list[i].pagepath
        data.data.list[i].textRemark = data.data.list[i].remark

        data.data.list[i].isModify = false
      }
      this.loading = false
      this.tableData = data.data.list
      this.total = data.data.total
    },
    async addcread() {
      if (this.form.app_id === '') {
        this.$message.error('请填写app_id')
        return
      }
      if (this.form.name === '') {
        this.$message.error('请填写小程序名称')
        return
      }
      if (this.form.gh_id === '') {
        this.$message.error('请填写gh_id')
        return
      }
      if (this.form.pagepath === '') {
        this.$message.error('请填写路径')
        return
      }
      if (this.form.source_material_id === null) {
        this.$message.error('请选择图片')
        return
      }
      // this.form.source_material_img = this.source_material_img
      await kfmpstore(this.form)
      this.accountlist()
      this.rest()
      this.$message({
        message: '添加成功',
        type: 'success'
      })
    },

    rest() {
      this.form.app_id = ''
      this.form.name = ''
      this.form.gh_id = ''
      this.form.pagepath = ''
      this.form.remark = null
      this.form.source_material_id = null
      this.source_material_img = ''
    },

    // 确定修改
    async confirmAccount(item) {
      const data = await kfmpupdate({
        id: item.id,
        app_id: item.textAppId,
        name: item.textName,
        gh_id: item.textGhId,
        pagepath: item.textPagepath,
        remark: item.textRemark
      })
      this.accountlist()
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      console.log(data)
    },

    // 删除
    async deleteAccount(id) {
      await delteMicro(id)
      this.$message({
        message: '删除成功',
        type: 'success'
      })
      this.accountlist()
    },

    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.accountlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.accountlist()
    },
    resback() {
      this.rest()
    },
    async updatae() {
      const data = await fetchUpMiniPrograms()
      console.log(data)
      this.$message({
        message: '刷新成功',
        type: 'success'
      })
      this.accountlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.form_box{
  /* margin-top: 30px; */
  padding: 10px 10px 0px 10px;
}
 /* ::v-deep .el-switch__core{
    width: 70px !important;
} */
.titip{
    width: 150px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /* 这里是超出几行省略 */
    overflow: hidden;
    margin: 0 auto;
    text-align: center;
}
</style>
